import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import I18n from 'I18n';

const isIframed = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return false;
  }
};

export default class GoogleLoginButton extends Component {
  render() {
    return /*#__PURE__*/_jsxs("a", {
      onClick: this.props.onClick,
      className: `google-sign-in${this.props.smartLogin ? ' smart-login' : ''}`,
      target: isIframed() ? '_blank' : '_self',
      children: [/*#__PURE__*/_jsx("span", {
        className: "icon"
      }), /*#__PURE__*/_jsx("span", {
        className: "buttonText",
        children: I18n.text('login.form.connected')
      })]
    });
  }

}